import {
  inject,
  observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component, useState,
} from 'react';
import {
  Button,
  Modal,
} from '@material-ui/core';
import {
  DatePicker,
} from '@material-ui/pickers';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import {
  FacilityStore,
} from '../../mobx-store/stores/facilitiesStore';
import SearchFilterDropdown, {
  IProps as ISearchDropDownProps,
} from '../../components/SearchFilterComponent/SearchFilterDropdown';

import {
  IRatingFacilitiesReportsOptions,
  IFacilityResponsesListOptions,
  IUserFormResponse,
} from '../../mobx-store/storeInterfaces/facilitiesInterface';
import classes from './styles.module.scss';

import {
  FacilityFormStore,
} from '../../mobx-store/stores/facilityFormStore';

interface ISearchDropDownFilterProps extends ISearchDropDownProps {
  ref?: React.RefObject<SearchFilterDropdown>;
}

interface IProps extends WithSnackbarProps {
  countryStore: CountryStore;
  facilityStore: FacilityStore;
  facilityFormStore: FacilityFormStore;
  match: any;
  history: any;
  location: any;
}

interface IState {
  start: Date | null;
  end: Date | null;
  isModalOpen: boolean;
  isSearchApplied: boolean;
  rating: number;
}

@inject('facilityStore')
@inject('countryStore')
@inject('facilityFormStore')
@observer

class FacilityResponseReports extends Component<IProps, IState> {
  addButton: any;

  categoriesList: any;

  ratingList: any;

  areasList: any;

  branchesList: any;

  tableHeader: any = [];

  facilityId: number;

  tableData: any;

  tableCellTypes: TableCellTypes[] = [];

  title: string = translate('facilitiesListPageTitle', {
  });

  searchFiltersProps: ISearchDropDownFilterProps[] = [];

  constructor(props: IProps) {
    super(props);
    this.state = {
      isSearchApplied: false,
      start: null,
      end: null,
      isModalOpen: false,
      rating: 0,
    };
    this.facilityId = this.props.match.params.facilityId;
  }

  asyncSetState = async <K extends keyof IState>(state: Pick<IState, K>) => new Promise((res) => {
    this.setState({
      ...state,
    }, () => res());
  });

  handleStartDateChanged = (startDate: Date) => {
    this.setState({
      start: startDate,
    });
  };

  handleEndDateChanged = (endDate: Date) => {
    this.setState({
      end: endDate,
    });
  };

  filter = async () => {
    const {
      start,
      end,
    } = this.state;

    if (!start || !end) {
      SnackBarComponent.getInstance().openSnackbar(
        'Choose start and end date please!',
        3000,
        'error',
      );
      return;
    }

    if (start > end) {
      SnackBarComponent.getInstance().openSnackbar(
        'start date can\'t be after end date!',
        3000,
        'error',
      );
      return;
    }
    try {
      const options: IFacilityResponsesListOptions = {
        availableCountries: this.props.countryStore.managedCountries,
        from: start,
        to: end,
        rating: this.state.rating ? this.state.rating : undefined,
      };
      this.setState({
        isSearchApplied: true,
      });
      await this.props.facilityStore.getFacilityResponsesList(this.facilityId, options);
    } catch (error) {
      console.log(error);
      SnackBarComponent.getInstance().openSnackbar(
        'Error while Filtering',
        3000,
        'error',
      );
    }
  };

  handleRatingChange = async (rating: number) => {
    try {
      this.setState({
        rating,
      });
      const options: IFacilityResponsesListOptions = {
        rating,
        availableCountries: this.props.countryStore.managedCountries,
        from: this.state.start ? this.state.start : undefined,
        to: this.state.end ? this.state.end : undefined,
      };

      //await this.props.facilityStore.getFacilityResponsesList(this.facilityId, options);
    } catch (error) {
      throw error;
    }
  };

  getRatingList = () => ({
    value: this.state.rating,
    onChange: this.handleRatingChange.bind(this),
    filters: [
      {
        value: 1,
        name: '1',
      },
      {
        value: 2,
        name: '2',
      },
      {
        value: 3,
        name: '3',
      },
      {
        value: 4,
        name: '4',
      },
      {
        value: 5,
        name: '5',
      },
    ],
  });

  getSearchFilterProps = () => [
    {
      label: 'Filter by Rating',
      searchFilterDropdown: this.ratingList,
      ref: React.createRef<SearchFilterDropdown>(),
    },
  ];

  handleClearFilter = async () => {
    this.setState({
      start: null,
      end: null,
    });
    if (!this.state.isSearchApplied) { return; }

    this.searchFiltersProps.map((searchFilterProp) => {
      if (searchFilterProp.ref!.current) {
        searchFilterProp.ref!.current.clear();
      }
    });

    const options: IRatingFacilitiesReportsOptions = {
      availableCountries: this.props.countryStore.managedCountries,
    };

    this.setState({
      isSearchApplied: false,
    });
    await this.props.facilityStore.getFacilityResponsesList(this.facilityId, options);
  };

  getFacilityTableHeader = () => {
    const headers = [
      {
        title: translate('facilityResponseNameColumn', {
        }),
      },
      {
        title: translate('facilityResponseMembershipColumn', {
        }),
      },
      {
        title: translate('facilityResponseRatingColumn', {
        }),
      },
      {
        title: translate('facilityResponseDetailsColumn', {
        }),
      },
    ];

    return headers;
  };

  handleTableButtonCellClicked = async (index: number, key: string) => {
    try {
      const {
        userFormResponseId,
      } = this.props.facilityStore.facilityResponseList[index];
      await this.props.facilityFormStore.getUserFormResponse(userFormResponseId);

      this.setState({
        isModalOpen: true,
      });
    } catch (error) {
      throw error;
    }
  };

  handleExport = async () => {
    const options: IFacilityResponsesListOptions = {
        availableCountries: this.props.countryStore.managedCountries,
        from: this.state.start || undefined,
        to: this.state.end || undefined,
        rating: this.state.rating || undefined,
      };
      await this.props.facilityStore.exportFacilityResponsesList(this.facilityId, options);
    };

  handleClose = () => {
    this.setState({
      isModalOpen: false,
    });
  };

  getRatingFacilityTableCellTypes = (): TableCellTypes[] => {
    const cellTypes: TableCellTypes[] = [
      {
        cellType: 'Text',
        key: 'name',
      },
      {
        cellType: 'Text',
        key: 'membershipId',
      },
      {
        cellType: 'Text',
        key: 'value',
      },
      {
        cellType: 'Button',
        key: 'view',
        onClick: this.handleTableButtonCellClicked,
      },
    ];

    return cellTypes;
  };

  getTableData = () => this.props.facilityStore.facilityResponseList
    .map((facility) => ({
      ...facility,
      view: 'View',
    }));

  initTable = () => {
    this.tableHeader = this.getFacilityTableHeader();
    this.tableCellTypes = this.getRatingFacilityTableCellTypes();
    this.tableData = this.getTableData();
  };

  render() {
    this.initTable();
    this.ratingList = this.getRatingList();
    this.searchFiltersProps = this.getSearchFilterProps();
    const userFormResponse = this.props.facilityFormStore.userFormResponse
      ? this.restructureUserFormResponse(this.props.facilityFormStore.userFormResponse) : null;

    return (
      <div>
        {!!userFormResponse && (
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.isModalOpen}
          className={classes.modalContainer}
          onClose={this.handleClose}
        >
          <div className={classes.modalCard}>
            <h2>User: </h2>
            <li>
              Membership ID:
              {' '}
              {userFormResponse.user.membershipId}
            </li>
            <li>
              Name:
              {' '}
              {`${userFormResponse.user.firstName} - ${userFormResponse.user.firstNameAr}`}
            </li>
            <div>
              <h2>Form: </h2>
              <li>
                Name:
                {' '}
                {userFormResponse.questionsForm.title}
              </li>
            </div>

            {userFormResponse.numericalResponses.map((response) => (
              <div>
                <h3>
                  Q:
                  {' '}
                  {response.questionTitle}
                </h3>
                <li>
                  Answer:
                  {' '}
                  {response.value}
                </li>
              </div>
            ))}

            {userFormResponse.textResponses.map((response) => (
              <div>
                <h3>
                  Q:
                  {' '}
                  {response.questionTitle}
                </h3>
                <li>
                  Answer:
                  {' '}
                  {response.value}
                </li>
              </div>
            ))}

            {userFormResponse.multipleChoiceResponses.map((response) => (
              <div>
                <h3>
                  Q:
                  {' '}
                  {response.questionTitle}
                </h3>
                <li>
                  Answer:
                  {' '}
                  {response.choice}
                </li>
              </div>
            ))}
          </div>
        </Modal>
        )}

{
                    this.searchFiltersProps.map((searchFilterProp) => (
                      <SearchFilterDropdown
                        label={searchFilterProp.label}
                     searchFilterDropdown={searchFilterProp.searchFilterDropdown}
                     ref={searchFilterProp.ref}
                      />
                    ))
                }
                
        <div className={classes.datePickerContainer}>
          <DatePicker
            variant="inline"
            className={classes.datePicker}
            label="Search By Date From"
            name="startdatasearch"
            format="dd/MM/yyyy"
            value={this.state.start}
            views={['year', 'month', 'date']}
            onChange={(value) => {
              this.handleStartDateChanged(value as any);
            }}
          />
          <DatePicker
            variant="inline"
            className={classes.datePicker}
            label="To"
            name="enddatasearch"
            format="dd/MM/yyyy"
            value={this.state.end}
            views={['year', 'month', 'date']}
            onChange={(value) => {
              this.handleEndDateChanged(value as any);
            }}
          />
        </div>


                        {/* <div className={classes.filterButton}>
   
        </div> */}
        <div className={classes.filterButton}>
        <Button
            onClick={this.filter}
            color="primary"
            variant="contained"
          >
            Filter
          </Button>
          <Button
            onClick={this.handleClearFilter}
            color="primary"
            variant="contained"
          >
            Clear
          </Button>
          <Button
            onClick={this.handleExport}
            color="primary"
            variant="contained"
          >
            Export
          </Button>
        </div>
        <GeneralTableComponent
          emptyMessage={translate('facilitiesListNoFacilitiesMessage', {
          })}
          title={this.title}
          tableHeader={this.tableHeader}
          tableData={this.tableData}
          tableCellTypes={this.tableCellTypes}
          addButton={this.addButton}
          loadingStatus={[
            this.props.countryStore.getManagedCountriesRequestStatus,
            this.props.facilityStore.getFacilitiesRequestStatus,
          ]}
        />
      </div>
    );
  }

  async componentDidMount() {
    const {
      countryStore,
      facilityStore,
    } = this.props;

    await countryStore.getUserManagedCountries();

    const options: IRatingFacilitiesReportsOptions = {
      availableCountries: this.props.countryStore.managedCountries,
    };

    await facilityStore.getFacilityResponsesList(this.facilityId, options);
  }

  restructureUserFormResponse(userFormResponseData: any): IUserFormResponse {
    try {
      const numericalResponses = userFormResponseData.numericalQuestionFormResponses.map((response: any) => ({
        value: response.value,
        questionTitle: response.question.title,
      }));

      const textResponses = userFormResponseData.textQuestionFormResponses.map((response: any) => ({
        value: response.value,
        questionTitle: response.question.title,
      }));

      const multipleChoiceResponses = userFormResponseData.questionOptionsFormResponses.map((response: any) => ({
        choice: response.questionOption.value,
        questionTitle: response.questionOption.question.title,
      }));

      const mappedUserFormResponseData: IUserFormResponse = {
        userFormResponseId: userFormResponseData.userFormResponseData,
        user: userFormResponseData.user,
        questionsForm: userFormResponseData.questionsForm,
        numericalResponses,
        textResponses,
        multipleChoiceResponses,
      };

      return mappedUserFormResponseData;
    } catch (error) {
      throw error;
    }
  }
}

export default FacilityResponseReports;
